import { render, staticRenderFns } from "./CeremonyEventDetails.vue?vue&type=template&id=be909d08&scoped=true"
import script from "./CeremonyEventDetails.vue?vue&type=script&lang=js"
export * from "./CeremonyEventDetails.vue?vue&type=script&lang=js"
import style0 from "./CeremonyEventDetails.vue?vue&type=style&index=0&id=be909d08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be909d08",
  null
  
)

export default component.exports